<template>
  <b-card>
    <table-holidays />
  </b-card>
</template>

<script>
import TableHolidays from '@/layouts/components/TableHolidays.vue'

import {
  BCard,
} from 'bootstrap-vue'

export default {
  components: {
    TableHolidays,
    BCard,
  },
}
</script>
